
































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { trim } from "../../../../util";
import Api from "../../../../api/index";
import request from "../../../../api/request";
import { getCookie, getStorage } from "@szgc/plt-core-v2";
import { Loading } from "element-ui";
import { SzgcFormGetor } from "@/index";

@Component({
  name: "DoneFormPageMobile",
  components: {
    SzgcFormGetor
  }
})
export default class DoneFormPageMobile extends Vue {
  @Prop({
    type: Object,
    default() {
      return null;
    }
  })
  private dataAll!: any;

  @Prop({
    type: [Number, String],
    default: ""
  })
  private status!: any;

  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  private runTimeFields!: any;

  private isEdit: boolean = false;
  private editBtn: any = {
    enable: false
  };
  private flowData: any = null;
  private formConfig: any = {
    auths: "",
    formRenderData: "",
    results: "",
    pacId: "",
    businessId: "",
    businessName: "",
    reqToken: ""
  };
  private buttonList: any = [];
  private nowBtn: any = null;
  private modalShow: boolean = false;
  private form: any = {
    fileName: "",
    fileId: "",
    idea: ""
  };
  private rules: any = {};
  private fileUpdLoading: any = null;
  private reqToken: string = "";
  private prefix: string = "";
  private token: any = "";

  @Watch("dataAll", { immediate: true, deep: true })
  private getData(newVal: any) {
    if (newVal) {
      this.prefix = getCookie("plt-api-route") || getStorage("plt-api-route") || "";
      this.token = getCookie("SZGC-SHIRO-TOKEN") || getStorage("SZGC-SHIRO-TOKEN") || "";
      // if (localStorage.getItem('offline') && localStorage.getItem('offline') === "true") {
      // }
      this.flowData = JSON.parse(JSON.stringify(newVal));
      this.reqToken = this.flowData.reqToken;
      this.formConfig = {
        ...this.flowData,
        auths: this.flowData.auths,
        formRenderData: this.flowData.formRender,
        results: this.flowData.fields,
        pacId: this.flowData.pacId,
        businessId: this.flowData.businessId,
        businessName: this.flowData.businessName,
        reqToken: this.reqToken
      };
      this.getFlowData();
    }
  }

  /*处理按钮*/
  async getFlowData() {
    const buttonList: any = [];
    if (this.flowData.actions && this.flowData.actions.length > 0) {
      this.flowData.actions.map((item: any) => {
        buttonList.push(item);
      });
    }
    this.editBtn = this.flowData.edit;
    this.buttonList = buttonList;
  }

  /*退出编辑*/
  cancelEdit() {
    this.isEdit = false;
    this.$emit("childEvt", { type: "refresh" });
  }

  /*点击按钮*/
  async clickBtn(item: any) {
    this.nowBtn = item;
    if (this.nowBtn.needSecondSubmit) {
      //有二次提交
      this.rules = {
        fileName: [{ required: item.ifAttRequire, message: "附件不能为空" }]
      };
      this.form = {
        fileName: "",
        fileId: "",
        idea: ""
      };
      this.modalShow = true;
    } else {
      this.rules = null;
      if (this.nowBtn.btnKey === "edit") {
        //修改
        this.editAction();
      } else {
        //其它按钮
        this.todoAction();
      }
    }
  }

  /*弹窗确定*/
  async sureEvt() {
    let flag;
    await (this.$refs.wbenModalForm as any).validate((valid: any) => {
      flag = valid;
    });
    if (flag) {
      if (this.nowBtn.btnKey === "edit") {
        this.editAction();
      } else {
        this.todoAction();
      }
    }
  }

  /*除修改确定*/
  async todoAction() {
    let formBoxData: any = {};
    if (this.nowBtn.btnKey === "repeal" || this.nowBtn.btnKey === "terminate") {
      //撤销repeal 终止terminate
      const allData = (await (this.$refs.wbenDoneFormComponent as SzgcFormGetor).getFormValues(
        false
      )) as any;
      formBoxData = allData.data;
    } else {
      const allData = (await (
        this.$refs.wbenDoneFormComponent as SzgcFormGetor
      ).getFormValues()) as any;
      if (!allData.valid) {
        this.$message.error(allData.message ? allData.message : "操作失败，有必填项未填!");
        return false;
      }
      formBoxData = allData.data;
    }
    try {
      const { success, message } = await request({
        url: this.prefix + Api.doneActFunc(),
        method: "post",
        data: {
          attIds: this.form.fileId === "" ? null : this.form.fileId,
          btnKey: this.nowBtn.btnKey,
          businessId: this.flowData.businessId,
          ccs: null,
          fields: formBoxData,
          idea: trim(this.form.idea),
          reqToken: this.reqToken,
          procTaskId: this.flowData.task.procTaskId
        }
      });
      if (!success) {
        this.$message.error(`${this.nowBtn.btnName}失败:${message}`);
        return false;
      }
      this.$message.success(`${this.nowBtn.btnName}成功`);
      this.modalShow = false;
      this.$emit("childEvt", { type: "close" }); //触发完直接关闭弹窗
    } catch (error: any) {
      this.$message.error(`${this.nowBtn.btnName}失败:${error}`);
    }
  }

  /*修改确定*/
  async editAction() {
    const allData = (await (
      this.$refs.wbenDoneFormComponent as SzgcFormGetor
    ).getFormValues()) as any;
    let formBoxData: any = {};
    if (!allData.valid) {
      this.$message.error(allData.message ? allData.message : "操作失败，有必填项未填!");
      return false;
    }
    formBoxData = allData.data;
    try {
      const { success, message } = await request({
        url: this.prefix + Api.doneEditFunc(),
        method: "post",
        data: {
          attIds: this.form.fileId === "" ? null : this.form.fileId,
          businessId: this.flowData.businessId,
          ccs: null,
          fields: formBoxData,
          idea: trim(this.form.idea),
          reqToken: this.reqToken,
          procTaskId: this.flowData.task.procTaskId
        }
      });
      if (!success) {
        this.$message.error(`${this.nowBtn.btnName}失败:${message}`);
        return false;
      }
      this.$message.success(`${this.nowBtn.btnName}成功`);
      this.modalShow = false;
      this.$emit("childEvt", { type: "close" }); //触发完直接关闭弹窗
    } catch (error: any) {
      this.$message.error(`${this.nowBtn.btnName}失败:${error}`);
    }
  }

  /*多文件上传点击*/
  showMulUpload() {
    (document.getElementById("doneUploadFile") as any).value = "";
    (document.getElementById("doneUploadFile") as HTMLDivElement).click();
  }

  /*多文件上传*/
  multiUpload(event: any) {
    let files = event.target.files;
    let formData = new FormData();
    if (files.length === 0) {
      return false;
    }
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    this.fileUpdLoading = Loading.service({
      lock: true,
      fullscreen: true,
      text: "附件上传中...",
      background: "rgba(255, 255, 255, 0.8)"
    });
    request({
      url: this.prefix + Api.mulUploadFiles,
      method: "post",
      data: formData
    })
      .then((res: any) => {
        if (res.success) {
          let tempIds: any = [],
            tempNames: any = [];
          if (res.data && res.data.length && res.data.length > 0) {
            res.data.map((item: any) => {
              tempIds.push(item.fileId);
              tempNames.push(item.name);
            });
          }
          this.form.fileName = tempNames.join(",");
          this.form.fileId = tempIds;
          this.$message.success("附件上传成功");
        } else {
          this.form.fileName = "";
          this.form.fileId = [];
          this.$message.error("附件上传失败");
        }
        this.fileUpdLoading.close();
      })
      .catch((error: any) => {
        this.form.fileName = "";
        this.form.fileId = [];
        this.fileUpdLoading.close();
        this.$message.error("附件上传失败: " + error);
      });
  }

  /*返回Form Box的数据*/
  async getBackFormData() {
    const data: any = await (this.$refs.wbenDoneFormComponent as SzgcFormGetor).getFormValues();
    return data;
  }
}
